import { Download, FileText } from "lucide-react";
import { OCT_DECK, ONE_PAGER } from "./data";
import { Reveal, SectionHead } from "./shared";

const Card = ({ doc, primary }) => (
  <a
    data-testid={doc.testid}
    href={doc.href}
    download
    className={`group flex h-full flex-col rounded-lg border p-7 transition-all duration-300 hover:-translate-y-1 ${
      primary
        ? "border-[#FF5500]/60 bg-[#111827] hover:border-[#FF5500] hover:shadow-[0_0_40px_rgba(255,85,0,0.15)]"
        : "border-slate-800 bg-[#0D1320] hover:border-slate-600"
    }`}
  >
    <div className="flex items-start justify-between">
      <FileText className={`h-7 w-7 ${primary ? "text-[#FF5500]" : "text-slate-400"}`} strokeWidth={1.6} />
      {primary && (
        <span className="rounded-full border border-[#FF5500]/40 bg-[#FF5500]/10 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-widest text-[#FF7A33]">
          Current
        </span>
      )}
    </div>
    <h3 className="font-display mt-6 text-xl font-semibold uppercase leading-snug tracking-wide text-slate-100">
      {doc.title}
    </h3>
    <p className="mt-2 font-mono text-xs uppercase tracking-widest text-slate-500">{doc.meta}</p>
    <span className="mt-auto flex items-center gap-2 pt-6 font-mono text-xs font-semibold uppercase tracking-widest text-[#FF5500] transition-colors group-hover:text-[#FF7A33]">
      <Download className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" />
      {doc.action}
    </span>
  </a>
);

export default function Materials() {
  return (
    <section id="materials" data-testid="materials-section" className="border-y border-slate-800 bg-[#0C111C]">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <SectionHead
          index="07"
          overline="Materials"
          title="The documents, as filed"
          note="The October 2026 investor deck and the $250K one-pager. Nothing older, nothing aspirational."
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Reveal className="h-full">
            <Card doc={OCT_DECK} primary />
          </Reveal>
          <Reveal delay={0.1} className="h-full">
            <Card doc={ONE_PAGER} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
